export const PARALLEL_JOB_ACTIONS = [
  'collectDeviceConfigurations',
  'configurationExport',
  'rebuildDataPolicyAcl',
  'snapshotDownload',
  'toggleMcp',
] as const;

export type ParallelJobAction = (typeof PARALLEL_JOB_ACTIONS)[number];
